import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { updateSecurityOptions } from '../../../store/actions/user';
import { ChangeSecurityOptionsSchema } from '../../../helpers/schemas';
import { FieldMessages } from '../../layout/Messages/FieldMessages';
import { NOTIFICATIONS_CHANGE_ACCOUNT_SECURITY } from '../../../config/notifications';
import { FEATURE_PASSKEY } from '../../../config/features';
import { PageSurface } from '../../layout/Workspace';

function SecurityComponent(props) {
  const { updateSecurityOptions, profile } = props;

  if (! FEATURE_PASSKEY) {
    return null;
  }

  return (
    <PageSurface
      className="profile-panel profile-security-panel"
      header={<h2 className="profile-panel-title"><FormattedMessage id="components.pages.profile.edit_profile.security_title" /></h2>}
    >
        <Formik
          initialValues={{ passkey_auth: !!(profile?.passkey_auth) }}
          validationSchema={ChangeSecurityOptionsSchema}
          enableReinitialize={true}
          validateOnChange={false}
          handleOnChange={true}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            const { passkey_auth } = values;
            updateSecurityOptions(passkey_auth);
            setSubmitting(false);
          }}
        >
          {props => (
            <Fragment>
              <Form>
                <Row>
                  <Col lg="12">
                    <Row>
                      <Col lg="6">
                        <FormattedMessage id="components.pages.profile.edit_profile.passkey_auth" />
                      </Col>
                      <Col lg="6" className="text-right">
                        <label className="custom-toggle ml-1 px-4 mb-4">
                          <input
                            type="checkbox"
                            name="passkey_auth"
                            checked={props.values.passkey_auth}
                            onChange={event => { props.setFieldValue("passkey_auth", !!event.target.checked) }}
                          />
                          <span className="custom-toggle-slider rounded-circle" />
                        </label>
                        <FieldMessages
                          color="danger"
                          class="small-field-error-align-end"
                          formikProps={props}
                          showDismiss={false}
                          name="passkey_auth"
                          notificationId={NOTIFICATIONS_CHANGE_ACCOUNT_SECURITY}
                        >
                          <ErrorMessage name="passkey_auth" component="div" data-testid="errors-passkey_auth" className="no-input-margin" />
                        </FieldMessages>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <FormattedMessage id="components.pages.profile.edit_profile.change_security_options_btn">
                    {
                      valueBtn => <Field className="my-4 btn btn-primary mx-auto" type="submit" value={valueBtn} onMouseEnter={() => { props.validateForm() }} />
                    }
                  </FormattedMessage>
                </Row>
              </Form>
            </Fragment>
          )}
        </Formik>
    </PageSurface>
  );
}


const mapStateToProps = state => ({
  profile: state.user.profile,
});

const mapActionsToProps = {
  updateSecurityOptions
};

const Security = connect(mapStateToProps, mapActionsToProps)(SecurityComponent);
export { Security, SecurityComponent };
